module.exports = __webpack_public_path__ + "static/img/风险可控.bd75cfc7.png";